import Box from "@mui/material/Box"
import PropTypes from "prop-types"

import { userAuthCardSx } from "../userAuthStyles"

export default function AuthLiquidSurface({ children, sx, ...props }) {
  return (
    <Box sx={{ ...userAuthCardSx, ...sx }} {...props}>
      {children}
    </Box>
  )
}

AuthLiquidSurface.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
}
